// extracted by mini-css-extract-plugin
export var imgContainer = "styles-module--imgContainer--kqaqG";
export var img = "styles-module--img---iemi";